<div class="toolbar-container" *ngIf="toolbarData">
  <div class="site-info">
    <div class="site-items">
      <div class="site-name"></div>
      <div class="agent-name">
        {{ toolbarData.srcAgent }}
      </div>
    </div>
    <div class="sites-separator" *ngIf="toolbarData.dstAgent">
      <i class="mdi mdi-ray-start-vertex-end"></i>
    </div>
    <div class="site-items">
      <div class="site-name"></div>
      <div *ngIf="toolbarData.dstAgent" class="agent-name">
        {{ toolbarData.dstAgent }}
      </div>
    </div>
  </div>
  <ng-container *ngIf="actionItems && !testInfoValue.isActionHidden && isActionApplicable()">
    <button
      class="test-info-action-btn"
      [matMenuTriggerFor]="menu"
      mat-button
      aria-label="Action menu"
    >
      {{ actionItems.title }}
      <mat-icon class="detail-action-btn-icon">arrow_drop_down</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <div class="mat-dropdown-menu-with-icons">
        <div *ngFor="let list of actionItems.menuItem">
          <button
            class="mat-menu-item-btn"
            mat-menu-item
            *ngIf="list.visible"
            [ngClass]="{ 'disable-button': list.disable }"
            [disabled]="list.disable"
            (click)="onActionClick(list.id)"
          >
            <i class="t-icon mdi" [ngClass]="list.iconName"></i>
            <span>{{ list.option }}</span>
          </button>
        </div>
      </div>
    </mat-menu>
  </ng-container>
</div>
